import { put, select } from 'redux-saga/effects';
import { selectors, withOffset } from '../../Stream';
import { getBrowseDeviationStreamId } from '../helpers';
import { getSearchQuery } from '../selectors';
export default function*() {
    const searchQuery = yield select((state)=>getSearchQuery(state));
    const streamId = getBrowseDeviationStreamId(searchQuery);
    const isFetching = yield select(selectors.isFetching, streamId);
    if (isFetching) {
        return;
    }
    yield put(withOffset.actions.fetch(streamId));
}
